import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useInternalUserGet, useUserGet } from 'core/types'

import ModelLink from './ModelLink'

type UserLinkProps = {
  userId: string
}

const UserLink: FC<UserLinkProps> = ({ userId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: internalUser, isLoading } = useInternalUserGet({
    companyId,
    userId,
    options: {
      throwOnError: (error) => R.isNot(isNotFoundError)(error),
    },
  })

  const { data: publicUser } = useUserGet({
    userId,
    options: {
      throwOnError: (error) => R.isNot(isNotFoundError)(error),
    },
  })

  return (
    <ModelLink
      id={userId}
      isLoading={isLoading}
      model={internalUser ?? publicUser}
    />
  )
}

export default UserLink
